import { render, staticRenderFns } from "./hTypeMatching.vue?vue&type=template&id=7bd3822b&scoped=true&"
import script from "./hTypeMatching.vue?vue&type=script&lang=js&"
export * from "./hTypeMatching.vue?vue&type=script&lang=js&"
import style0 from "./hTypeMatching.vue?vue&type=style&index=0&id=7bd3822b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3822b",
  null
  
)

export default component.exports